import type { GameCategory } from "../../shared/types.ts";

export type SceneVariant = "voxel" | "tracers" | "terrain" | "hero" | "radar" | "default";

/** `a` is the dominant accent of a game's page, `b` the secondary tint. Both are hex strings. */
export interface GameTheme { a: string; b: string }

const BRAND: GameTheme = { a: "#ff3d4f", b: "#ff8a3d" };

const THEMES: Record<string, GameTheme> = {
  "mc-java": { a: "#5fd35f", b: "#c9a25f" },
  "mc-bedrock": { a: "#34d6a4", b: "#d6b36a" },
  cs2: { a: "#ff8a3d", b: "#ffd36b" },
  csgo: { a: "#f0a63a", b: "#7ab0ff" },
  "ark-ase": { a: "#2dd4bf", b: "#f2a33a" },
  "ark-asa": { a: "#3be0c4", b: "#ffb347" },
  ow2: { a: "#ff9a1f", b: "#eaf2ff" },
  "war-thunder": { a: "#a8bd52", b: "#ffc247" },
};

const CATEGORY_THEMES: Partial<Record<GameCategory, GameTheme>> = {
  survival: { a: "#2dd4bf", b: "#f2a33a" },
  fps: { a: "#ff8a3d", b: "#ffd36b" },
  sandbox: { a: "#5fd35f", b: "#c9a25f" },
};

const VARIANTS: Record<string, SceneVariant> = {
  "mc-java": "voxel", "mc-bedrock": "voxel",
  cs2: "tracers", csgo: "tracers",
  "ark-ase": "terrain", "ark-asa": "terrain",
  ow2: "hero",
  "war-thunder": "radar",
};

const CATEGORY_VARIANTS: Partial<Record<GameCategory, SceneVariant>> = { sandbox: "voxel", fps: "tracers", survival: "terrain" };

export const themeFor = (id: string, category?: GameCategory): GameTheme =>
  THEMES[id] ?? (category && CATEGORY_THEMES[category]) ?? BRAND;

export const variantFor = (id: string, category?: GameCategory): SceneVariant =>
  VARIANTS[id] ?? (category && CATEGORY_VARIANTS[category]) ?? "default";
